import React, { useContext, useRef } from "react";
import styled from "styled-components";

import { BrowserContext } from "../../../../providers/BrowserContext";
import { useElementSize } from "../hooks/useElementSize";

const Styled = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;
const StyledMain = styled.div`
  flex: 1;
  min-width: 0;
`;
const StyledPreview = styled.div`
  flex: 1.5;
  border-left: solid 2px #ccc;
  min-width: 0;
`;

/** Picker layout component that is used by ItemPicker and PassagePicker */
const ItemPickerLayout = (props: {
  main: React.ReactNode;
  preview: React.ReactNode;
}) => {
  const [browserState] = useContext(BrowserContext);
  const ref = useRef<HTMLDivElement>(null);
  const size = useElementSize(ref);
  const showPreview = (size?.width ?? 0) > 800;
  const isNarrow = (size?.width ?? 0) < 800;

  return (
    <Styled ref={ref}>
      {isNarrow && browserState.focused ? (
        <>
          {browserState.focused && (
            <div style={{ flex: 1, minWidth: 0 }}>{props.preview}</div>
          )}
        </>
      ) : (
        <>
          <StyledMain>{props.main}</StyledMain>
          {!!browserState.focused && showPreview && (
            <StyledPreview>{props.preview}</StyledPreview>
          )}
        </>
      )}
    </Styled>
  );
};

export default ItemPickerLayout;
